import { render, staticRenderFns } from "./UserCreateOrDetails.vue?vue&type=template&id=001e6bad&"
import script from "./UserCreateOrDetails.vue?vue&type=script&lang=js&"
export * from "./UserCreateOrDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserCreateOrDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports